const urls = { 
    GET_STATE : "v3/shoptrendz/locations/states",
    GET_CATEGORIES : "v3/shoptrendz/categories",
    GET_BY_QUERY : "v3/shoptrendz/locations/query",
    GET_STATS : "v3/shoptrendz/stats",
    GET_CITY : "v3/shoptrendz/locations/cities",
    GET_DATA : "v3/shoptrendz/stats",
    GET_CATEGORY : "v3/shoptrendz/categories",
    FEEDBACK :"v3/shoptrendz/feedback",
    GET_STATS_v2 : "v3/trends/stats",
    RTO_HEAT_MAP : "v3/trends/heatmap",
    GET_GEO_DATA : "v3/trends/geographical",
    GET_PRODUCT_SUGGESTIONS : "v3/trends/suggested-questions?query=",
    GET_PRODUCT_STATS : "v3/trends/product-analytics",
    USER_LOGIN : "v3/trends/login",
    SEND_MESSAGE :"v4/trends/chat",
    TRENDS_FEEDBACK: "v4/trends/feedback",
    CUSTOMER_STATS: "v4/trends/customer-stats",
}

export default urls